ThemeJS.Sliders = ( function( $ ){

    $( '.posts-slider' ).slick({
        infinite:       true,
        dots:           false,
        arrows:         true,
        slidesToShow:   3,
        slidesToScroll: 1,
        centerMode:     false,
        prevArrow:      '<button type="button" class="slick-prev"><span class="sr-only">Previous</span><span class="fas fa-chevron-left"></span></button>',
        nextArrow:      '<button type="button" class="slick-next"><span class="sr-only">Next</span><span class="fas fa-chevron-right"></span></button>',
        responsive:     [
            {
                breakpoint: 991,
                settings:   {
                    slidesToShow:   2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 768,
                settings:   {
                    slidesToShow:   1,
                    slidesToScroll: 1
                }
            },
        ]
    });

    $( '.posts-slider' ).on( 'beforeChange', function(event, slick, currentSlide, nextSlide) { 
        let $progressBar    = $( this ).next( '.progress-bar' );  
        var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
        $progressBar
            .css('background-size', calc + '% 100%')
            .attr('aria-valuenow', calc );
    });

})( jQuery );